import {BffOofWeb, ConfigTemplatesCustomer, MeUser, OrderItemConfigurations, OrderItemDevices, OrderItems, Orders, RmaCustomer} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public BffOofWeb: BffOofWeb,
    public ConfigTemplatesCustomer: ConfigTemplatesCustomer,
    public MeUser: MeUser,
    public OrderItemConfigurations: OrderItemConfigurations,
    public OrderItemDevices: OrderItemDevices,
    public OrderItems: OrderItems,
    public Orders: Orders,
    public RmaCustomer: RmaCustomer,
  ) {}
}